const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntensiveCare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22.108,
    y: 15.27,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 44.9908 38.5389)",
    style: {
      fill: "#2C355E",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    width: 0.775,
    height: 7.998
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M26.218,15.862h-7.446 c-0.316,0-0.572-0.256-0.572-0.571v-4.925c0-0.316,0.256-0.571,0.572-0.571h7.446c0.316,0,0.571,0.256,0.571,0.571v4.925 C26.79,15.606,26.534,15.862,26.218,15.862z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M22.88,15.149l-0.81-3.443L21.427,13.3h-1.825c-0.101,0-0.183-0.082-0.183-0.183 s0.082-0.183,0.183-0.183h1.578l0.981-2.435l0.814,3.459l0.423-1.024h2.012c0.101,0,0.183,0.082,0.183,0.183 S25.512,13.3,25.41,13.3h-1.767L22.88,15.149z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M29.734,23.914H5.886 c-0.234,0-0.424-0.19-0.424-0.424v-8.866c0-0.092-0.03-0.181-0.085-0.255l-0.509-0.679c-0.141-0.187-0.103-0.453,0.085-0.594 l0.487-0.365c0.187-0.141,0.453-0.103,0.594,0.085l0.8,1.067c0.055,0.073,0.085,0.163,0.085,0.254v7.895 c0,0.234,0.19,0.424,0.424,0.424h22.39c0.234,0,0.424,0.19,0.424,0.424v0.609C30.158,23.724,29.968,23.914,29.734,23.914z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.153,
    y: 23.683,
    style: {
      fill: "#2C355E",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    width: 1.229,
    height: 1.712
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M29.817,19.679H14.063 c-0.094,0-0.183-0.039-0.248-0.107l-2.913-3.087c-0.345-0.366-0.922-0.382-1.288-0.037c-0.366,0.345-0.383,0.922-0.037,1.288 l3.452,3.658c0.064,0.068,0.154,0.107,0.248,0.107h16.54c0.188,0,0.34-0.152,0.34-0.34V20.02 C30.158,19.832,30.006,19.679,29.817,19.679z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M12.762,27.921 c0,1.144-0.927,2.071-2.071,2.071c-1.144,0-2.071-0.927-2.071-2.071c0-1.144,0.927-2.071,2.071-2.071 C11.835,25.85,12.762,26.777,12.762,27.921z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M13.212,5.479V5.384v0 c0.042-0.498-0.058-0.882-0.296-1.142c-0.288-0.314-0.671-0.318-0.687-0.318H8.734c-0.002,0-0.003-0.001-0.003-0.003V2.222 c0-0.002-0.001-0.003-0.003-0.003H7.851c-0.002,0-0.003,0.001-0.003,0.003v1.699c0,0.002-0.001,0.003-0.003,0.003H5.771 c-0.002,0-0.003,0.001-0.003,0.003v0.358c0,0.002,0.001,0.003,0.003,0.003h2.074c0.002,0,0.003,0.001,0.003,0.003v18.284 c0,0.002,0.001,0.003,0.003,0.003h0.878c0.002,0,0.003-0.001,0.003-0.003V4.291c0-0.002,0.001-0.003,0.003-0.003h3.493 c0.01,0,0.246,0.007,0.424,0.204c0.165,0.183,0.231,0.476,0.197,0.868c0,0,0,0,0,0l0,0.115c0,0.002-0.001,0.003-0.003,0.003 h-1.927c-0.002,0-0.003,0.001-0.003,0.003v4.261c0,0.418,0.406,0.758,0.905,0.758h1.011c0.002,0,0.003,0.001,0.003,0.003v1.487 c0,0.002,0.001,0.003,0.003,0.003h0.358c0.002,0,0.003-0.001,0.003-0.003v-1.487c0-0.002,0.001-0.003,0.003-0.003h1.011 c0.499,0,0.905-0.34,0.905-0.758V5.482c0-0.002-0.001-0.003-0.003-0.003H13.212z M14.75,6.98h-0.824 c-0.097,0-0.186,0.069-0.194,0.166c-0.009,0.108,0.076,0.198,0.182,0.198h0.837c0.002,0,0.003,0.001,0.003,0.003v0.366 c0,0.002-0.001,0.003-0.003,0.003H13.3c-0.097,0-0.186,0.069-0.194,0.166C13.096,7.99,13.181,8.08,13.287,8.08h1.462 c0.002,0,0.003,0.001,0.003,0.003v0.403c0,0.002-0.001,0.003-0.003,0.003h-0.824c-0.097,0-0.186,0.069-0.194,0.166 c-0.009,0.108,0.076,0.199,0.182,0.199h0.837c0.002,0,0.003,0.001,0.003,0.003v0.887c0,0.213-0.247,0.394-0.54,0.394h-2.393 c-0.293,0-0.54-0.18-0.54-0.394V5.846c0-0.002,0.001-0.003,0.003-0.003h3.468c0.002,0,0.003,0.001,0.003,0.003v1.131 C14.752,6.978,14.751,6.98,14.75,6.98z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 -16.3825 24.4481)",
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 6.176,
    cy: 21.852,
    rx: 3.839,
    ry: 3.839
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2C355E"
    },
    points: "8.775,20.756 7.255,20.756 7.255,19.236 5.166,19.236 5.166,20.756 3.645,20.756  3.645,22.845 5.166,22.845 5.166,24.366 7.255,24.366 7.255,22.845 8.775,22.845  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntensiveCare);
export default __webpack_public_path__ + "static/media/intensive_care.1a9810e66a8e878b8d0d85b8420fcfd6.svg";
export { ForwardRef as ReactComponent };